<!-- 音像 -->

<template>
  <div class="pressTabList2">
    <div class="rejects" v-if="opMsg && role == 'show'">
      <div class="rejLine">
        <div class="rejName">状态：</div>
        <div class="rejText">{{ msgStatus | filterMsgStatus }}</div>
      </div>
      <div class="rejLine">
        <div class="rejName">原因：</div>
        <div class="rejText">
          <div v-for="(item, index) in (opMsg || '').split('；')" :key="index" style="text-align: left">
            {{ item ? item + (index == (opMsg || "").split("；").length - 1 ? "" : "；") : "" }}
          </div>
          <!-- {{ opMsg }} -->
        </div>
      </div>
    </div>

    <div class="headBar">
      <span>材料1：工作总结</span>

      <!-- <el-select v-model="selYear" @change="valChange" size="medium" placeholder="历年记录" style="float:right;">
        <el-option v-for="item in selYears" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                  </el-select> -->

      <a @click="toCancel" class="downBtn" style="margin-right: 10px; margin-left: 10px">
        <el-button v-if="cancelFlag" type="danger" size="small">撤 回</el-button>
      </a>
    </div>
    <span></span>
    <div class="tabArea">
      <el-table :data="tabCage.tabDat1" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="materialTitle" label="材料名称" align="center"> </el-table-column>
        <el-table-column label="完成进度" align="center">
          <template slot-scope="scope">
            {{ scope.row.status | translate("pgress") }}
          </template>
        </el-table-column>
        <el-table-column label="更新时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.updatedAt | translate("time") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" v-if="scope.row.status == 2">
              <!-- <a :href="loadUrl" download>下载</a> -->
              <a @click="filesDown(scope.row)" download>下载</a>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="headBar">
      <span v-if="pressType == 1">材料2：音像制品出版单位年度核验表、音像制品出版情况表</span>
      <span v-if="pressType == 2">材料2：电子出版物出版单位年度核验表、电子出版物出版情况表</span>

      <a v-if="pressType == 1" :href="filrUrl1" class="downBtn" download>
        <el-button size="mini">下载封面和盖章页</el-button>
      </a>
      <a v-if="pressType == 2" :href="filrUrl2" class="downBtn" download>
        <el-button size="mini">下载封面和盖章页</el-button>
      </a>
    </div>

    <div class="subBar">
      <span v-if="pressType == 1">表1：音像制品出版单位年度核验表</span>
      <span v-if="pressType == 2">表1：电子出版物出版单位年度核验表</span>
      <!-- <a class="printbtn" :href="printUrl1" download><el-button  size="mini">打印</el-button></a> -->
    </div>

    <div class="tabArea">
      <table class="tabElement">
        <tr class="tabHead">
          <td>序号</td>
          <td>材料名称</td>
          <td>完成进度</td>
          <td>更新时间</td>
          <td colspan="2">操作</td>
        </tr>
        <tr v-for="(item, inx) in tabCage.tabDat2" :key="inx">
          <td>1-{{ inx + 1 }}</td>
          <td>{{ item.materialTitle }}</td>
          <td>{{ item.status | translate("pgress") }}</td>
          <td>{{ item.updatedAt | translate("time") }}</td>
          <td style="width: 120px">
            <el-button v-if="item.status == 2" type="primary" @click="toEdit(item)" size="mini">查看</el-button>
          </td>
          <td style="width: 120px" v-if="inx == 0" rowspan="7">
            <a href="javascript:void(0);" @click="dmyfile(1)" downLoad>
              <el-button size="mini">导出打印表</el-button>
            </a>
          </td>
          <td v-else-if="inx == 7">
            <a href="javascript:void(0);" @click="dmyfile(2)" downLoad>
              <el-button size="mini">导出打印表</el-button>
            </a>
          </td>
        </tr>
      </table>
      <!-- <el-table :data="tabCage.tabDat2" border style="width: 100%">
			                <el-table-column prop="date" label="序号" width="60" align="center">
			                     <template slot-scope="scope">
			                         1-{{ scope.row.materialCode.substr(2,3) }}
			                     </template>
			                </el-table-column>
			                <el-table-column prop="materialTitle" label="材料名称" align="center">
			                </el-table-column>
			                <el-table-column label="完成进度" align="center">
			                     <template slot-scope="scope">
			                     	  {{ scope.row.status | translate('pgress') }}
			                     </template>
			                </el-table-column>
			                <el-table-column label="更新时间" align="center">
			                     <template slot-scope="scope">
			                     	  {{ scope.row.updatedAt | translate('time')  }}
			                     </template>
			                </el-table-column>
			                <el-table-column label="操作" width="150" align="center">
			                     <template slot-scope="scope">
			                         <el-button v-if="scope.row.status == 2" @click="toEdit(scope.row)" size="mini">查看</el-button>
			                     </template>
                              			                </el-table-column>
                              			             </el-table> -->
    </div>

    <!-- <div class="subBar subBar2">
			             <span class="subTtl">人员基本情况登记表</span>
                              									 <a class="printbtn" :href="printUrl2" download><el-button  size="mini">打印</el-button></a>
			         </div> -->
    <!-- <div class="tabArea">
			             <el-table :data="tabCage.tabDat4" border style="width: 100%" >
			                <el-table-column prop="date" label="序号" width="60" align="center">
			                     <template slot-scope="scope">
			                          1-{{ scope.row.materialCode.substr(2,3) }}
			                     </template>
			                </el-table-column>
			                <el-table-column prop="materialTitle" label="材料名称" align="center">
			                </el-table-column>
			                <el-table-column label="完成进度" align="center">
			                     <template slot-scope="scope">
			                     	  {{ scope.row.status | translate('pgress') }}
			                     </template>
			                </el-table-column>
			                <el-table-column label="更新时间" align="center">
			                     <template slot-scope="scope">
			                     	  {{ scope.row.updatedAt | translate('time')  }}
			                     </template>
			                </el-table-column>
			                <el-table-column label="操作" width="150" align="center">
			                     <template slot-scope="scope">
			                         <el-button @click="toEdit(scope.row)" size="mini">查看</el-button>
			                     </template>
			                </el-table-column>
			             </el-table>

                              			         </div> -->

    <div class="subBar">
      <span v-if="pressType == 1">表2：音像制品出版情况表</span>
      <span v-if="pressType == 2">表2：电子出版物出版情况表</span>
    </div>

    <div class="tabArea">
      <table class="tabElement">
        <tr class="tabHead">
          <td>序号</td>
          <td>材料名称</td>
          <td>完成进度</td>
          <td>更新时间</td>
          <td colspan="2">操作</td>
        </tr>
        <tr v-for="(item, inx) in tabCage.tabDat3" :key="inx">
          <td>2-{{ inx + 1 }}</td>
          <td>{{ item.materialTitle }}</td>
          <td>{{ item.status | translate("pgress") }}</td>
          <td>{{ item.updatedAt | translate("time") }}</td>
          <td style="width: 120px">
            <el-button v-if="item.status == 2" @click="toEdit(item)" type="primary" size="mini">查看</el-button>
          </td>
          <td style="width: 120px">
            <a href="javascript:void(0);" @click="dmyfile(3)" downLoad>
              <el-button size="mini">导出打印表</el-button>
            </a>
          </td>
        </tr>
      </table>
      <!-- <el-table :data="tabCage.tabDat3" border style="width: 100%">
			                <el-table-column prop="date" label="序号" width="60" align="center">
			                    <template slot-scope="scope">2-1</template>
			                </el-table-column>
			                <el-table-column prop="materialTitle" label="材料名称" align="center">
			                </el-table-column>
			                <el-table-column label="完成进度" align="center">
			                     <template slot-scope="scope">
			                     	  {{ scope.row.status | translate('pgress') }}
			                     </template>
			                </el-table-column>
			                <el-table-column label="更新时间" align="center">
			                     <template slot-scope="scope">
			                     	  {{ scope.row.updatedAt | translate('time') }}
			                     </template>
			                </el-table-column>
			                <el-table-column label="操作" width="150" align="center">
			                     <template slot-scope="scope">
			                         <el-button @click="toEdit(scope.row)" size="mini">查看</el-button>
			                     </template>
                              			                </el-table-column>
                              			             </el-table> -->
    </div>

    <div class="progressTab" v-if="role == 'press'">
      <div class="headBar">
        <span>流转记录</span>
      </div>
      <el-table :data="tabDat" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="examineName" width="250" label="单位" align="center"></el-table-column>
        <el-table-column prop="name" width="120" label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row | tansStr("state") }}
          </template>
        </el-table-column>
        <el-table-column prop="examineMessage" min-width="300" label="审核意见" align="center">
          <template slot-scope="scope">
            <div
              v-for="(item, index) in (scope.row.examineMessage || '').split('；')"
              :key="index"
              style="text-align: left">
              {{ item ? item + (index == (scope.row.examineMessage || "").split("；").length - 1 ? "" : "；") : "" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="pubNumber" width="120" label="批准文号" align="center"></el-table-column>
        <el-table-column prop="checkdAt" width="150" label="操作时间" align="center">
          <template slot-scope="scope">
            {{ scope.row | tansStr("checkdAt") }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import UpBtn from "@/views/components/uploadBtn";
import {
  sUpdate0,
  cancelTabSubmit, // zym.撤销提交
} from "@/api/pressRole/pressRole";
import { successiveHistoryNew } from "@/api/provinceRole/provinceRole";
import { detFile, getFileToken } from "@/api/account";
import { expFile } from "@/api/export";
import { filesDownload, filesDownloadUploadBtn } from "@/api/file";
// import downLoad from 'downloadjs';

export default {
  components: {
    UpBtn,
  },
  props: ["pressType", "pressDat", "role", "organization", "selYears", "defaultYear", "cancelFlag"],
  data() {
    return {
      tabCage: {
        tabDat1: [],
        tabDat2: [],
        tabDat3: [],
        // tabDat4:[],
      },
      selYear: "",
      zeroStoreage: {
        id: "",
        publishMaterialId: "",
        publishId: "",
        fileId: "",
      },
      progress: "",
      msgStatus: "",
      opMsg: "",

      fileToken: "",
      loadUrl: "",

      filrUrl1: "",
      filrUrl2: "",

      printUrl1: "",
      printUrl2: "",
      printUrl3: "",

      //  审核历史
      tabDat: [],
    };
  },
  watch: {
    pressDat(curVal, oldVal) {
      this.pressInit();
      // 流转记录
      this.historyRecord();
    },
  },
  filters: {
    tansStr: function (dat, code) {
      if (code == "state") {
        // console.log('state=',dat.flowName,'  ' ,dat.status)
        if (dat.flowName == "开始") {
          let map = {
            0: "开始",
            7: "提交",
            21: "暂缓登记",
          };
          // console.log("dat.status=", dat.status, "  ", map[dat.status]);
          return map[dat.status];
        } else if (dat.flowName == "省局") {
          let map = {
            1: "通过",
            3: "退回",
            9: "整体上报",

            12: "暂缓",
            13: "注销或拟注销",
            14: "建议撤销",
            21: "暂缓登记",
            22: "暂缓登记",
          };
          return map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          let map = {
            1: "通过",
            2: "暂缓",
            3: "退回",
            4: "撤销",
            5: "注销或拟注销",
            10: "整体退回",
            9: "整体发布",
            21: "暂缓登记",
            22: "暂缓登记",
          };

          return map[dat.status];
        } else if (dat.flowName == "登记") {
          let map = {
            0: "待登记",
            1: "待登记",
            2: "已登记",
          };

          return map[dat.status];
        } else {
          return dat.flowName;
        }
      } else if (code == "checkdAt") {
        if (dat["checkdAt"] == "Invalid date") {
          return "";
        }
        return dat["checkdAt"].substr(0, 16);
      }
    },
    filterMsgStatus: function (code) {
      let map = {
        0: "待审核",
        1: "通过",
        2: "暂缓",
        3: "退回",
        4: "撤销",
        5: "注销",
        6: "全部",
        7: "已提交",
        8: "未提交",
        9: "整体提交",
        10: "整体退回",
        11: "已登记",
        12: "省局暂缓",
        13: "注销或拟注销",
        14: "建议撤销",
        15: "待审核（存在问题）",
        16: "待审核（省局暂缓）",
        17: "待审核（建议注销）",
        18: "待审核（建议撤销）",
        19: "待审核（省局通过）",
        21: "暂缓登记", // 省局整改
        22: "暂缓登记", // 出版署整改
      };
      return map[code] || "";
    },
    translate: function (dat, code) {
      // console.debug('translate: ', dat,code)
      if (code == "pgress") {
        let transArr = ["未提交", "已提交"];
        return transArr[dat - 1];
      } else if (code == "time") {
        return dat && dat.substr(0, 16);
      }
    },
  },
  methods: {
    // zym.流转记录
    historyRecord: function () {
      let dat = this.pressDat[0];
      this.examineId = dat.id;
      // console.log("流转记录：", this.examineId, " 年度：", this.selYear);

      successiveHistoryNew({ examineId: this.examineId, year1: this.selYear }).then((response) => {
        let flowData = response.fFlowTaskList;
        // 如果是出版社，需要显示出版社、省局、出版署的通过意见
        if (this.role == "press") {
          console.log("出版社...");
          this.tabDat = flowData.filter((item) => {
            if (item.flowName == "国家新闻出版署") {
              if (item.status == "1") {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          });
        } else {
          console.log("非出版社...");
          this.tabDat = flowData;
        }
      });
    },
    valChange: function () {
      this.$emit("valChangeSearch", this.selYear);
    },
    toEdit: function (row) {
      let urlMap = {
        201: "edsct_tab1",
        202: "edsct_tab2",
        203: "edsct_tab3",
        204: "edlct_tab4",
        205: "edlct_tab5",
        206: "edlct_tab6",
        207: "edsct_tab7",
        208: "edlct_tab8",
        301: "edlct_tab9",
        209: "edsct_tab10",
      };
      this.$router.push({
        path: urlMap[row.materialCode],
        query: {
          pressId: row.organizationId,
          mtId: row.id,
          pressType: this.pressType,
          role: this.role,
        },
      });
    },

    zeroStoreCtrls: function (dat) {
      let detAble = this.zeroStoreage.fileId;
      this.zeroStoreage.fileId = dat;
      sUpdate0({
        pfile1: this.zeroStoreage,
      })
        .then((response) => {
          if (detAble) {
            detFile({
              id: detAble,
            }).then((inresp) => {
              this.zeroStoreage.id = response.pfile1.id;
            });
          }
        })
        .catch((error) => {});
    },

    // zym.文件下载
    filesDown: function (dat) {
      if (dat.status == 1) {
        this.$message({
          message: "附件未上传",
          type: "error",
        });
      } else {
        // console.log('dat:', JSON.stringify(dat));
        if (dat.id && dat.materialCode) {
          var dataIn = {};
          dataIn.organizationMaterialId = dat.id;
          dataIn.code = dat.materialCode;
          dataIn.materialTitle = dat.materialTitle;
          dataIn.organizationId = dat.organizationId;
          // console.log(JSON.stringify(dat));
          filesDownloadUploadBtn(dataIn).then((response) => {
            window.open(response.payload.url);
          });
        }
      }
    },
    // zym.撤回
    toCancel: function () {
      let vm = this;
      this.$confirm("确认撤回吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          cancelTabSubmit({
            materialExamineId: this.postId,
            // type: 1 // zym.type类型不能要，音像、电子共用接口，nodejs根据examine来判断哪种类型
          }).then((response) => {
            loading.close();
            // console.log('response=', JSON.stringify(response));
            let tipCode = response.payload.tipCode;
            let tipMessage = response.payload.message || "操作失败";
            if (tipCode == "fail") {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "error",
              });
            } else {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.$router.push("pgress_step");
            }
          });
        })
        .catch((error) => {});
    },

    pressInit: function () {
      let dat = this.pressDat[0];
      let vm = this;
      console.debug("pressInit: ", dat);
      if (dat.reportUploadList) {
        this.tabCage.tabDat1 = dat.reportUploadList;
        this.tabCage.tabDat2 = dat.yearVerificationList;
        this.tabCage.tabDat3 = dat.licenseUploadList;

        // console.log('文件材料信息: ', JSON.stringify(this.tabCage.tabDat1))
        // console.log('dat.pFile1: ', JSON.stringify(dat.pFile1))
        // console.log('dat.pFile2: ', JSON.stringify(dat.pFile2))

        this.opMsg = dat.msg;
        this.msgStatus = dat.msgStatus;
        this.progress = dat.progress;
        this.postId = dat.reportUploadList[0].materialExamineId;

        // console.log('publishMaterialId1=', this.tabCage.tabDat1[0].id)
        // console.log('publishMaterialId2=', this.tabCage.tabDat2[0].id)

        // zym.因为整改报告、自查报告都是 code=101，所以根据材料名称做个判断
        let zichaReportFileId = undefined;
        let zhenggaiReportFileId = undefined;
        if (dat.pFile1 && dat.pFile1.length > 0) {
          // console.log('到达file1...')
          zichaReportFileId = dat.pFile1[0].id;
        }

        if (dat.pFile2 && dat.pFile2.length > 0) {
          // console.log('到达file2...,', dat.pFile2[0].id, ',', this.tabCage.tabDat1[1].id);
          zhenggaiReportFileId = dat.pFile2[0].id;
        }

        this.saveFileId(this.tabCage.tabDat1[0], zichaReportFileId, zhenggaiReportFileId);
        if (this.tabCage.tabDat1[1] != undefined) {
          this.saveFileId(this.tabCage.tabDat1[1], zichaReportFileId, zhenggaiReportFileId);
        }

        // 调节顺序
        if (this.tabCage.tabDat1[0].materialTitle == "整改报告") {
          // 有整改必有自查
          let tabDatTmp = this.tabCage.tabDat1[0];
          this.tabCage.tabDat1[0] = this.tabCage.tabDat1[1];
          this.tabCage.tabDat1[1] = tabDatTmp;
        }

        getFileToken().then((response) => {
          vm.loadUrl =
            process.env.BASE_API +
            "/File/File/download/token/" +
            response.resultStatus.token +
            "/id/" +
            dat.pFile1.fileId;
          //  vm.printUrl1 = process.env.BASE_API + '/File/File/printYxdzJbxx?type='+ vm.pressType + '&organizationId=' + vm.tabCage.tabDat2[0].organizationId +'&token=' + encodeURIComponent(vm.$store.getters.token);
          //vm.printUrl2 = process.env.BASE_API + '/File/File/printRyJbxx?type='+ vm.pressType + '&publishMaterialId=' + vm.tabCage.tabDat2[7].id +'&token=' + encodeURIComponent(vm.$store.getters.token);
          //vm.printUrl3 = process.env.BASE_API + '/File/File/printYxdzCbwqkb?type='+ vm.pressType + '&publishMaterialId=' + vm.tabCage.tabDat3[0].id+ '&organization=' + encodeURIComponent(vm.organization) +'&token=' + encodeURIComponent(vm.$store.getters.token);
        });
      }
    },
    saveZeroStoreage: function (publishMaterialId, publishId, fileId) {
      this.zeroStoreage[publishMaterialId] = {
        publishMaterialId,
        publishId,
        fileId,
      };
    },

    saveFileId: function (tabDat1Item, zichaReportFileId, zhenggaiReportFileId) {
      let zgbgPublishMaterialId, zcbgPublishMaterialId;
      if (tabDat1Item.materialTitle == "整改报告") {
        // 整改报告
        zgbgPublishMaterialId = tabDat1Item.id;
        this.saveZeroStoreage(zgbgPublishMaterialId, tabDat1Item.organizationId, zhenggaiReportFileId);
      } else {
        // 有时候不叫自查报告 而是工作报告（
        zcbgPublishMaterialId = tabDat1Item.id;
        this.saveZeroStoreage(zcbgPublishMaterialId, tabDat1Item.organizationId, zichaReportFileId);
      }
    },

    postPrevs: function () {
      return this.postId;
    },
    dmyfile: function (exp, obj) {
      let params = {};
      let expUrl = "";
      if (exp == 1) {
        expUrl = "/api/export/printYxdzJbxx";
        params = {
          firstYear: this.selYear,
          type: this.pressType,
          organizationId: this.tabCage.tabDat2[0].organizationId,
        };
      } else if (exp == 2) {
        expUrl = "/api/export/printRyJbxx";
        params = {
          firstYear: this.selYear,
          type: this.pressType,
          publishMaterialId: this.tabCage.tabDat2[7].id,
          organization: encodeURIComponent(this.organization),
          organizationId: this.tabCage.tabDat2[0].organizationId,
        };
      } else if (exp == 3) {
        expUrl = "/api/export/printYxdzCbwqkb";
        params = {
          firstYear: this.selYear,
          type: this.pressType,
          publishMaterialId: this.tabCage.tabDat3[0].id,
          organization: encodeURIComponent(this.organization),
          organizationId: this.tabCage.tabDat2[0].organizationId,
        };
      } else if (exp == 4) {
        expUrl = "/api/export/download";
        params = {
          id: this.pressDat[0].pFile1.fileId,
        };
      }
      console.debug("expUrl: ", expUrl);
      console.debug("params: ", params);
      expFile({
        expUrl: expUrl,
        p: params,
      })
        .then((blob) => {
          let blobHref = window.URL.createObjectURL(blob);
          let anchor = document.createElement("a");
          anchor.href = blobHref;
          var fname = localStorage.getItem("dfilename");
          anchor.download = decodeURIComponent(fname);
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(blobHref);
          document.body.removeChild(anchor);
        })
        .catch((error) => {});
    },
  },
  created: function () {
    this.selYear = this.defaultYear;
    console.debug("defaultYear: ", this.defaultYear);
    this.pressInit();
    // 流转记录
    this.historyRecord();
    //  this.filrUrl1 = process.env.BASE_API + '/File/File/downloadDrmb?code=0011&token=' + encodeURIComponent(this.$store.getters.token);
    //  this.filrUrl2 = process.env.BASE_API + '/File/File/downloadDrmb?code=0012&token=' + encodeURIComponent(this.$store.getters.token);
    this.filrUrl1 = process.env.URL_FILE + "/drmb/001.xlsx"; // 封面和盖章页
    this.filrUrl2 = process.env.URL_FILE + "/drmb/002.xlsx"; // 封面和盖章页
    console.log(typeof this.cancelFlag);
  },
};
</script>

<style lang="scss" type="text/css">
.pressTabList2 {
  font-size: 14px;
  letter-spacing: 0.72px;

  .downBtn {
    float: right;

    span {
      font-size: 12px;
    }
  }

  .rejects {
    border: 1px solid red;
    color: red;
    padding: 15px 0px;
    border-radius: 3px;

    .rejLine {
      position: relative;
      line-height: 20px;

      .rejName {
        width: 70px;
        text-align: right;
        float: left;
      }

      .rejText {
        margin-left: 65px;
      }
    }
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    margin-top: 9px;
    color: #666666;
  }

  .tabArea {
    margin-top: 12px;
    padding-bottom: 24px;

    .tabElement {
      width: 100%;

      .tabHead {
        font-size: 14px;
        font-weight: bold;

        td {
          // background: #f5f7fa;
          padding: 15px 20px;
          color: #909399;
        }
      }

      td {
        border-collapse: collapse;
        border: 1px solid #ebeef5;
        text-align: center;
        padding: 12px;
        color: #606266;
      }
    }
  }

  .subBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    margin-top: 6px;
    color: #666666;

    .printbtn {
      width: 60px;
      float: right;
    }

    .subTtl {
      margin-left: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// SpecCommonTab.vue?43a83076